export const permissionGroupKeys = {
  documentPermissionsAll: ['DOCUMENT_PERMISSIONS'] as const,
  documentPermissions: (documentId: number | string) => ['DOCUMENT_PERMISSIONS', { documentId }],
  sectionPermissionsAll: ['SECTION_PERMISSIONS'] as const,
  sectionPermissions: (documentId: number | string, selectedOrganization: unknown) => ['SECTION_PERMISSIONS', { documentId, selectedOrganization }],
};
